import { cloneDeep } from 'lodash'

import { Services, joinURLPath } from '@sigma-frontend-libs/commons'

import { globalErrorHandler, permissionPresets, request } from '@/utils'

import { serviceNameViaPoint } from '@/components/services/url-shortener-settings/domains/utils'
import { domainsUsers } from '@/components/services/url-shortener-settings/utils'

import render from './render'

export default {
  name: 'DomainsUsers',

  mixins: [ domainsUsers ],

  props: {
    userId: String
  },

  data() {
    return {
      createLoading: false,
      initDomainIds: [],
      initDomainIdsInitialized: false
    }
  },

  computed: {
    canCreateDomains() {
      return this.checkPermissions(`advanced.${serviceNameViaPoint}.create`, permissionPresets.true)
    },

    hasChanges() {
      const domainIds = JSON.stringify(this.domainIds)
      const initDomainIds = JSON.stringify(this.initDomainIds)

      return domainIds !== initDomainIds
    },

    disabled() {
      return this.createLoading || this.loading || !this.hasChanges
    },

    domainIds: {
      get() {
        return this.domainsUsers.reduce((acc, { domainId }) => {
          acc.push(domainId)

          return acc
        }, [])
      },
      set(value) {
        let nextDomainIds
        if (Array.isArray(value)) {
          nextDomainIds = value
        } else {
          nextDomainIds = []
        }
        this.domainsUsers = nextDomainIds.map(id => {
          return { domainId: id }
        })
      }
    }
  },

  watch: {
    loading(value, previous) {
      if (previous && !value && !this.initDomainIdsInitialized) {
        this.initDomainIds = cloneDeep(this.domainIds)
        this.initDomainIdsInitialized = true
      }
    }
  },

  methods: {
    async createDomainsUsers() {
      if (!this.canCreateDomains) {
        return
      }

      try {
        this.createLoading = true
        const pathToApi = [
          'n',
          Services['url-shortener-settings'],
          'domains-users'
        ].join('/')
        const response = await request.patch(joinURLPath(pathToApi, this.userId), { body: { domainIds: this.domainIds } })
        let domainsUsers
        if (Array.isArray(response)) {
          domainsUsers = response
        } else if (response) {
          domainsUsers = response.data
        }

        if (Array.isArray(domainsUsers)) {
          await this.getDomainsByUser()
          this.initDomainIds = cloneDeep(this.domainIds)
          this.initDomainIdsInitialized = true
          this.addSnackbar({
            text: this.getTranslate(`${serviceNameViaPoint}.snackbars.domainsUsers.created`),
            type: 'success'
          })
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.createLoading = false
      }
    }
  },

  render
}
